import { observable } from "mobx";
import { Type } from "class-transformer";
import CustomerRefundCandidateChargeResponse from "./customerRefundCandidateChargeResponse";
import RefundPaymentType from "./refundPaymentType";
import RejectedCustomerRefundCandidatePermittedActionsResponse from "./rejectedCustomerRefundCandidatePermittedActionsResponse";
import RejectedCustomerRefundCandidateStatus from "./rejectedCustomerRefundCandidateStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RejectedCustomerRefundCandidateResponse {
  id!: string;

  @observable
  @Type(() => Date)
  rejectionDate!: Date;

  @observable
  status!: RejectedCustomerRefundCandidateStatus;

  @observable
  officialRecordId!: string;

  @observable
  refundAmount!: number;

  @observable
  originalPaymentAmount?: number;

  @observable
  variableSymbol!: number;

  @observable
  @Type(() => CustomerRefundCandidateChargeResponse)
  charge!: CustomerRefundCandidateChargeResponse;

  @observable
  refundPaymentType!: RefundPaymentType;

  @observable
  @Type(() => RejectedCustomerRefundCandidatePermittedActionsResponse)
  permittedActions!: RejectedCustomerRefundCandidatePermittedActionsResponse;
}
